/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftDownIcon24Solid = forwardRef('ArrowDUturnLeftDownIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6 10.5a8.5 8.5 0 0 1 17 0v6a1.5 1.5 0 0 1-3 0v-6a5.5 5.5 0 1 0-11 0v5.983l3.056-3.259a1.5 1.5 0 1 1 2.188 2.052l-4.53 4.833a3 3 0 0 1-4.378 0l-4.53-4.833a1.5 1.5 0 1 1 2.188-2.052L6 16.43V10.5Z" })));
});
